export default __webpack_public_path__ + "static/media/gallery_05.e9139b6a.jpg";